/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Jump to target helper class
 **/
define([
	'../drill-through/jumpTo/JumpToTarget',
	'underscore'
], function(JumpToTarget, _){

	class JumpToActionHelper {

		/**
		* Static function to retrieve 'Jump to' targets
		*
		* @param {string} sourceId - the data source id
		* @param {array} drillDefinitions - collection of drill target definitions
		* @param {array} selections - selected data point values
		*
		* @return {object} object containing jump to targets
		*/
		static getJumpToTargets = function(options) {
			options = options || {};
			const drillDefinitions = options.drillDefinitions;
			const sourceId = options.sourceId;

			const targetsMap = {};
			const targets = [];

			_.each(drillDefinitions, function(entry) {
				const modelRefs = entry.getModelRefs();
				for(let count = 0; count < modelRefs.length; count++) {
					if (modelRefs[count] === sourceId) {
						const jumpToTarget = new JumpToTarget( {
							content: options.content,
							dashboardAPI: options.dashboardApi,
							drillDefinitionEntry: entry,
							selections: options.selections
						});
						targetsMap[entry.getId()] = jumpToTarget;
						targets.push(jumpToTarget);
						break;
					}
				}
			});
			return { targets : targets, targetsMap: targetsMap };
		};

	}
	return JumpToActionHelper;
});
